import http from '@/utils/http'

export const movementFieldApi = (): any => http.get(`/hrm/movement/field`, {})

export const movementFieldValueApi = (employeeId: string): any =>
  http.get(`/hrm/movement/field/value?employeeId=${employeeId}`, {})

// 获取字典 - 薪酬模板
export const getSalaryDict = (): IResponseType<any> =>
  http.post('/salary/base/templates', { paged: false, enable_status: 1 })
